import process from "node:process";
import type { AppMeta } from "@calcom/types/App";

export const metadata = {
  name: "Kalienda vidéo",
  description:
    "Kalienda vidéo est la plateforme de visioconférence intégrée, basée sur le web et propulsée par Daily.co. Minimaliste et légère, elle offre l'essentiel des fonctionnalités dont vous avez besoin.",
  installed: !!process.env.DAILY_API_KEY,
  type: "daily_video",
  variant: "conferencing",
  url: "https://daily.co",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Kalienda",
  category: "conferencing",
  slug: "daily-video",
  title: "Kalienda vidéo",
  isGlobal: true,
  email: "help@cal.com",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:daily",
      label: "Kalienda vidéo",
    },
  },
  key: { apikey: process.env.DAILY_API_KEY },
  dirName: "dailyvideo",
  isOAuth: false,
} as AppMeta;

export default metadata;
